import React from 'react'
import axios from 'axios'

import { makeStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import ErrorMsg from './ErrorMsg'
import SuccessMessage from './SuccessMessage'
import LoadingSpinner from '../../generalComponents/loadingSpinner/LoadingSpinner.js'

import {
  KarumbeTextField,
  KarumbeBigTextField,
  KarumbeButton
} from '../../karumbe_components'

import { usePromiseTracker, trackPromise } from 'react-promise-tracker'

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: 'auto',
    marginBottom: 'auto',
    height: 'auto',
    width: '100%',
    backgroundColor: '#55c5c1'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    paddingTop: '5px'
  },
  card: {
    width: '100%',
    maxWidth: '750px',
    marginTop: '5%',
    marginBottom: '3%',
    backgroundColor: 'rgb(32, 122, 126,0.95)'
  },
  title: {
    color: 'white',
    fontFamily: 'TovariSans'
  },
  previewWrapper: {
    width: '100%',
    textAlign: 'center',
    marginTop: '15px'
  },
  previewImage: {
    maxWidth: '100%',
    maxHeight: '260px',
    borderRadius: '12px',
    objectFit: 'cover'
  },
  fileInput: {
    width: '100%',
    color: 'white',
    marginTop: '10px'
  },
  labelFoto: {
    color: 'white',
    width: '100%',
    fontFamily: 'TovariSans'
  },
  checkboxLabel: {
    color: 'white'
  },
  textareaWrapper: {
  width: '100%'
    },
    textareaLabel: {
      color: 'white',
      fontFamily: 'TovariSans',
      display: 'block',
      marginBottom: '6px'
    },
    textareaNoticias: {
      width: '100%',
      boxSizing: 'border-box',
      backgroundColor: 'white',
      color: 'black',
      border: '1px solid #ccc',
      borderRadius: '4px',
      padding: '12px',
      fontSize: '16px',
      fontFamily: 'Arial, sans-serif',
      resize: 'vertical',
      outline: 'none',
      lineHeight: '1.4',
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap'
    },
textareaNoticiasError: {
  border: '2px solid #f44336'
}
}))

function obtenerFechaActual () {
  const fecha = new Date()
  const year = fecha.getFullYear()
  const month = String(fecha.getMonth() + 1).padStart(2, '0')
  const day = String(fecha.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export default function ScreenAltaNoticia (props) {
  const classes = useStyles()
  const apiURL = process.env.REACT_APP_API_URL

  const [error, setError] = React.useState(false)
  const [openError, setOpenError] = React.useState(false)
  const [openSuccess, setOpenSuccess] = React.useState(false)
  const [message, setMessage] = React.useState('')

  const [noticia, setNoticia] = React.useState({
    categoria: '',
    titulo: '',
    resumen: '',
    contenido: '',
    fechaPublicacion: obtenerFechaActual(),
    publicada: true,
    foto: '',
    pdf: '',
    nombrePdf: ''
  })

  const categorias = [
    'EDUCACIÓN',
    'RESCATE',
    'CONSERVACIÓN',
    'ALERTA',
    'INVESTIGACIÓN'
  ]

  const { promiseInProgress } = usePromiseTracker()

  function limpiarFormulario () {
    setError(false)
    setOpenError(false)
    setOpenSuccess(false)

    setNoticia({
        categoria: '',
        titulo: '',
        resumen: '',
        contenido: '',
        fechaPublicacion: obtenerFechaActual(),
        publicada: true,
        foto: '',
        pdf: '',
        nombrePdf: ''
      })
  }

  const handleChange = attribute => event => {
    setNoticia({
      ...noticia,
      [attribute]: event.target.value
    })
  }

  function handleChangePublicada (event) {
    setNoticia({
      ...noticia,
      publicada: event.target.checked
    })
  }

  function handleChangeFoto (event) {
    const archivo = event.target.files[0]

    if (!archivo) {
      return
    }

    if (!archivo.type.startsWith('image/')) {
      setMessage('El archivo seleccionado debe ser una imagen.')
      setOpenError(true)
      return
    }

    const reader = new window.FileReader()

    reader.onload = function () {
      /*
       * Esto genera:
       * data:image/jpeg;base64,/9j/4AAQ...
       *
       * Es exactamente lo que necesita el endpoint de noticias.
       */
      setNoticia({
        ...noticia,
        foto: reader.result
      })
    }

    reader.onerror = function () {
      setMessage('No se pudo leer la imagen seleccionada.')
      setOpenError(true)
    }

    reader.readAsDataURL(archivo)
  }

  function quitarFoto () {
    setNoticia({
      ...noticia,
      foto: ''
    })
  }
  
  function handleChangePdf (event) {
    const archivo = event.target.files[0]

    if (!archivo) {
      return
    }

    const esPdf =
      archivo.type === 'application/pdf' ||
      archivo.name.toLowerCase().endsWith('.pdf')

    if (!esPdf) {
      setMessage('El archivo seleccionado debe ser un PDF.')
      setOpenError(true)
      return
    }

    const reader = new window.FileReader()

    reader.onload = function () {
      /*
       * Esto genera:
       * data:application/pdf;base64,JVBERi0x...
       */
      setNoticia({
        ...noticia,
        pdf: reader.result,
        nombrePdf: archivo.name
      })
    }

    reader.onerror = function () {
      setMessage('No se pudo leer el PDF seleccionado.')
      setOpenError(true)
    }

    reader.readAsDataURL(archivo)
  }

  function quitarPdf () {
    setNoticia({
      ...noticia,
      pdf: '',
      nombrePdf: ''
    })
  }

  function validarFormulario () {
    if (
      noticia.categoria === '' ||
      noticia.titulo.trim() === '' ||
      noticia.resumen.trim() === '' ||
      noticia.contenido.trim() === '' ||
      noticia.fechaPublicacion === '' ||
      noticia.foto === ''
    ) {
      return false
    }

    return true
  }

  function guardarNoticia (event) {
        event.preventDefault()

        if (!validarFormulario()) {
          setError(true)
          setMessage('Por favor complete todos los campos obligatorios, incluida la foto.')
          setOpenError(true)
          setOpenSuccess(false)
          window.scrollTo(0, 0)
          return
        }

        const url = `${apiURL}/noticias`

        const noticiaRequest = {
            categoria: noticia.categoria,
            titulo: noticia.titulo.trim(),
            resumen: noticia.resumen.trim(),
            contenido: noticia.contenido.trim(),
            fechaPublicacion: noticia.fechaPublicacion,
            publicada: noticia.publicada,
            foto: noticia.foto,
            pdf: noticia.pdf
          }

        const accessToken = localStorage.getItem('accessToken')

        if (!accessToken) {
          setMessage('No hay sesión iniciada. Inicie sesión para guardar noticias.')
          setOpenError(true)
          setOpenSuccess(false)
          window.scrollTo(0, 0)
          return
        }

        trackPromise(
          axios.post(url, noticiaRequest, {
            headers: {
              Authorization: accessToken.startsWith('Bearer ')
                ? accessToken
                : 'Bearer ' + accessToken
            }
          })
            .then(response => {
              limpiarFormulario()
              setMessage('La noticia fue guardada correctamente.')
              setOpenSuccess(true)
              setOpenError(false)
              window.scrollTo(0, 0)
            })
            .catch(responseError => {
              console.log('Error guardando noticia:', responseError)

              if (responseError.response) {
                console.log('Status:', responseError.response.status)
                console.log('Data:', responseError.response.data)
              }

              if (responseError.response && responseError.response.status === 401) {
                setMessage('No está autenticado. Inicie sesión nuevamente.')
              } else if (responseError.response && responseError.response.status === 403) {
                setMessage('Su usuario no tiene permisos para guardar noticias.')
              } else {
                setMessage('Hubo un error al guardar la noticia.')
              }

              setOpenError(true)
              setOpenSuccess(false)
              window.scrollTo(0, 0)
            })
        )
      }

  function cancelar () {
    limpiarFormulario()
    window.scrollTo(0, 0)
  }

  return (
    <div className={classes.container}>
      <Card className={classes.card}>
        <ErrorMsg
          open={openError}
          onHandleOpen={() => { setOpenError(!openError) }}
          message={message}
        />

        <SuccessMessage
          open={openSuccess}
          handleOpen={() => { setOpenSuccess(!openSuccess) }}
          message={message}
        />

        {promiseInProgress
          ? (
            <CardContent>
              <LoadingSpinner />
            </CardContent>
          )
          : (
            <CardContent>
              <Typography
                align='center'
                className={classes.title}
                variant='h4'
              >
                Alta de noticia
              </Typography>

              <form
                className={classes.container}
                noValidate
                autoComplete='off'
                onSubmit={guardarNoticia}
              >
                <List className={classes.root}>
                  <ListItem>
                    <TextField
                      select
                      label='Categoría*'
                      value={noticia.categoria}
                      onChange={handleChange('categoria')}
                      error={noticia.categoria === '' && error}
                      fullWidth
                      variant='filled'
                    >
                      {categorias.map(categoria => (
                        <MenuItem key={categoria} value={categoria}>
                          {categoria}
                        </MenuItem>
                      ))}
                    </TextField>
                  </ListItem>

                  <ListItem>
                    <KarumbeTextField
                      label='Título*'
                      placeholder='Título de la noticia'
                      value={noticia.titulo}
                      maxLength={255}
                      onChange={handleChange('titulo')}
                      error={noticia.titulo.trim() === '' && error}
                    />
                  </ListItem>

                 <ListItem>
                    <div className={classes.textareaWrapper}>
                      <label className={classes.textareaLabel}>
                        Resumen*
                      </label>

                      <textarea
                        className={
                          classes.textareaNoticias +
                          (noticia.resumen.trim() === '' && error
                            ? ' ' + classes.textareaNoticiasError
                            : '')
                        }
                        rows={3}
                        maxLength={1000}
                        value={noticia.resumen}
                        placeholder='Resumen corto para mostrar en el carrusel'
                        onChange={handleChange('resumen')}
                      />
                    </div>
                  </ListItem>

                  <ListItem>
                    <div className={classes.textareaWrapper}>
                      <label className={classes.textareaLabel}>
                        Contenido*
                      </label>

                      <textarea
                        className={
                          classes.textareaNoticias +
                          (noticia.contenido.trim() === '' && error
                            ? ' ' + classes.textareaNoticiasError
                            : '')
                        }
                        rows={8}
                        maxLength={10000}
                        value={noticia.contenido}
                        placeholder='Texto completo de la noticia'
                        onChange={handleChange('contenido')}
                      />
                    </div>
                  </ListItem>

                  <ListItem>
                    <TextField
                      label='Fecha de publicación*'
                      type='date'
                      value={noticia.fechaPublicacion}
                      onChange={handleChange('fechaPublicacion')}
                      error={noticia.fechaPublicacion === '' && error}
                      fullWidth
                      variant='filled'
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </ListItem>

                  <ListItem>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={noticia.publicada}
                          onChange={handleChangePublicada}
                          color='primary'
                        />
                      }
                      label='Publicada'
                      classes={{
                        label: classes.checkboxLabel
                      }}
                    />
                  </ListItem>

                  <ListItem>
                    <div style={{ width: '100%' }}>
                      <Typography className={classes.labelFoto}>
                        Foto*
                      </Typography>

                      <input
                        className={classes.fileInput}
                        type='file'
                        accept='image/*'
                        onChange={handleChangeFoto}
                      />

                      {noticia.foto && (
                        <div className={classes.previewWrapper}>
                          <img
                            src={noticia.foto}
                            alt='Vista previa de la noticia'
                            className={classes.previewImage}
                          />

                          <div>
                            <KarumbeButton
                              label='Quitar foto'
                              onClick={quitarFoto}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </ListItem>
                  
                  <ListItem>
                    <div style={{ width: '100%' }}>
                      <Typography className={classes.labelFoto}>
                        PDF adjunto
                      </Typography>

                      <input
                        className={classes.fileInput}
                        type='file'
                        accept='application/pdf,.pdf'
                        onChange={handleChangePdf}
                      />

                      {noticia.pdf && (
                        <div className={classes.previewWrapper}>
                          <Typography style={{ color: 'white' }}>
                            PDF seleccionado: {noticia.nombrePdf || 'documento.pdf'}
                          </Typography>

                          <div>
                            <KarumbeButton
                              label='Quitar PDF'
                              onClick={quitarPdf}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </ListItem>

                  <ListItem>
                    <KarumbeButton
                      label='Cancelar'
                      onClick={cancelar}
                    />

                    <KarumbeButton
                      label='Guardar noticia'
                      onClick={guardarNoticia}
                    />
                  </ListItem>
                </List>
              </form>
            </CardContent>
          )}
      </Card>
    </div>
  )
}